<template>
  <v-row no-gutters class="body-2">
    <template v-if="table">
      <v-col
        v-for="(item, index) in data"
        :key="index"
        cols="4"
      >
        <v-sheet class="secondary py-1 text-center">{{item.name}}</v-sheet>
        <v-sheet class="py-2 text-center">{{item.value}}</v-sheet>
      </v-col>
    </template>

    <template v-else>
      <template
        v-for="(item, index) in data"
      >
        <v-col cols="6" :key="`name:${index}`">
          <v-sheet class="secondary py-2 text-center">{{item.name}}</v-sheet>
        </v-col>
        <v-col cols="6" :key="`value:${index}`">
          <v-sheet class="py-2 text-center">{{item.value}}</v-sheet>
        </v-col>
      </template>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'CDataTable',
  props: {
    data: {
      type: Array,
      required: true
    },
    table: {
      type: Boolean,
      default: false
    }
  }
}
</script>
